import { createContext } from 'react';

export type WhatsNewContextProps = {
  openWhatsNew: () => void;
};

export const WhatsNewContext = createContext<WhatsNewContextProps>({
  openWhatsNew: () => undefined,
});
